import { Spinner } from "@a2z/ui-v2";

/**
 * The gate shown while the session is being fetched — before `AppShell`, and
 * so before the portal has any chrome at all.
 *
 * It is a spinner and nothing else. It used to be a titled card whose heading
 * and body both read "Loading…", which is the same word twice and a level-one
 * heading for a state that is not a page.
 */
export function Surface({
  locale,
  direction,
  label,
}: {
  locale: string;
  direction: "rtl" | "ltr";
  /** Announced to screen readers; nothing is drawn for it. */
  label: string;
}) {
  return (
    <main
      dir={direction}
      lang={locale}
      className="flex min-h-[100svh] items-center justify-center bg-canvas p-6"
    >
      <Spinner label={label} />
    </main>
  );
}
